import React from 'react'
import { useParams, useNavigate, generatePath } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'
import { API, Router } from 'app'
import { BackCrumbs, useDataLoader } from 'component/Util'

export const AdminHomePage = () => {
    const params = useParams()
    const validationLoader = useDataLoader()
    const navigate = useNavigate()

    // add button onclick handler 
    const onClick = async () => {
        await validationLoader.fetch(API.endpoints.ADMIN_VALIDATE_DATA);
    }
    const renderFn = (data) => {
        return <>
        <pre>
            { JSON.stringify(data, null, 2) }
        </pre>
        </>
    }
    return <>
        <Button variant="primary" onClick={onClick}>Validate Data</Button>
        { validationLoader.view(renderFn) }
    </>
}
